import { Lock } from '@/components/Lock';
import { TPage } from '@/types';
import { Typography } from '@data-products-and-ai/react-components';

import book_red from '@/assets/books/book_red.jpg';
import book_yellow from '@/assets/books/book_yellow.jpg';
import book_blue from '@/assets/books/book_blue.jpg';
import book_green from '@/assets/books/book_green.jpg';

const returnBook = (team: string) => {
  if (team === 'red') return book_red;
  if (team === 'yellow') return book_yellow;
  if (team === 'blue') return book_blue;
  if (team === 'green') return book_green;
};
const Book = ({ team }: Partial<TPage>) => {
  if (!team) return null;
  return (
    <div style={{ textAlign: 'center', padding: 20 }}>
      <Typography>
        <div style={{ marginBottom: 20 }}>
          <img
            src={returnBook(team)}
            alt=""
            style={{ width: 300, height: 'auto' }}
          />
        </div>
        We, cats, love to read but, this time, it comes with the challenge to
        find the book above.
        <br />
        <br />
        In the page number that matches the number of years from Siemens in
        Portugal you will find the next clue.
      </Typography>
    </div>

    /*   <Lock
      target={target}
      lockType="image"
      combination="3,0,2,1,4,5,7,6,9,8"
      text={
        <Typography tag="h1">
          Great job so fAr but aRe you All aGain prEpared? Go aROUND the message
          and Find aLl yOu need tO be in the Right path!
        </Typography>
      }
    /> */
  );
};

export default Book;
